import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { MenuModule } from '../menu/menu.module';
import { AppRoutingModule } from '../../app-routing.module';


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    MenuModule,
    AppRoutingModule
  ],
  exports: [
    HomeComponent,
  ]
})
export class HomeModule { }
